import { render, staticRenderFns } from "./StartConversation.vue?vue&type=template&id=0847534a&"
import script from "./StartConversation.vue?vue&type=script&lang=js&"
export * from "./StartConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports